module.exports = __webpack_public_path__ + "img/reset.4ffc9f83.svg";